// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".studentTable[data-v-4526bd16] {\n  padding: 20px;\n}\n.el-table[data-v-4526bd16]::before {\n  height: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
